<div class="produto-video" *ngIf="_url != null">
      <iframe width="100%" height="480" [src]="_url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>      